function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { MDCPopOver } from "../../jsx/components/mdc-components";
import { ButtonIcon, ButtonClose } from "../ui";
import { Button } from '@progress/kendo-react-buttons';
export default class extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onClick", event => {
      this.show();
      if (this.props.onButtonClick) this.props.onButtonClick(event);
    });
    _defineProperty(this, "onCloseClick", event => {
      this.hide();
    });
    _defineProperty(this, "show", () => {
      this.popover.classList.add('open');
    });
    _defineProperty(this, "hide", () => {
      this.popover.classList.remove('open');
    });
  }
  componentDidMount() {}
  render() {
    var color = this.props.color;
    if (!color) color = 'primary';
    var cls = 'popover-element';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: "relative-2"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.onClick
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, this.props.icon), " ", this.props.label), /*#__PURE__*/React.createElement("div", {
      className: cls,
      ref: ref => this.popover = ref
    }, /*#__PURE__*/React.createElement(ButtonClose, {
      onClick: this.onCloseClick
    }), this.props.children));
  }
}